<!-- <div class="loading-overlay" *ngIf="loading">
  <app-custom-spinner></app-custom-spinner>
</div> -->
<div class="page-holder align-items-center py-4 bg-gray-100 vh-100" (click)="closesnackbar()">
  <div class="container" style="max-width: 100%;">
    <div class="row align-items-center">
      <div class="col-lg-4 " style="padding-left: 0px;padding-right: 0px;">
        <div>
          <img src="../../assets/img/login_image.png" height="650" style="width: 120%;">
          <button class="btn btn-primary text-white px-2 reload_text imgOverButton">
            <img src="../../assets/img/flash-circle.svg" height="30px;">&nbsp;&nbsp;
            <label style="color: white;font-size: 14px;">One<span style="color: gold">QMS</span></label>
          </button>
          <button *ngIf="oneQmsOrgImagesDetails.loginpageContent !=null"
            class="text-white px-2 reload_text imgOverButton1">
            <img src="../../assets/img/microscope.svg" height="20px;"
              style="background-color: #4650dd;float: left;"><br>
            <!-- <span style="font-size: 11px;">Reduce Overall Time and Cost spent on Clinical Trials and Redefining your End-to-End IT Ecosystem with Innovative Technologies.</span> -->


            <span style="font-size: 11px;">{{oneQmsOrgImagesDetails.loginpageContent}}</span>
          </button>
        </div>
        <div class="d-none card">
          <div class="card-header px-lg-5">
            <div class="card-heading text-primary">
              <h1>One-QMS</h1>
            </div>
          </div>
          <div class="card-body p-lg-5">
            <h3 class="mb-4">Hi, Welcome Back!</h3>
            <form id="loginForm" action="index.html" #form="ngForm">
              <div class="form-floating mb-3">
                <input class="form-control " type="text" id="floatingInput" autocomplete="off"
                  [(ngModel)]="userSettings.userName" (focusout)="onFocusOutEvent($event)"
                  [ngModelOptions]="{standalone: true}" placeholder="Username" required>
                <label>Username</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control pw-field" type="passsword" id="floatingPassword" autocomplete="off"
                  onpaste="return false;" ondrop="return false;" [(ngModel)]="userSettings.password"
                  [ngModelOptions]="{standalone: true}" placeholder="Password" required>
                <label>Password</label>
              </div>
              <div *ngIf="organisationName">
                <div class="form-floating mb-3">
                  <input class="form-control" id="floatingInput" type="name" [(ngModel)]="userSettings.orgName"
                    placeholder="Organisation Name" [ngModelOptions]="{standalone: true}" required>
                  <label>Organisation Name</label>
                </div>
              </div>
              <div class="form-check mb-3">
              </div>
              <div class="textalign">
                <!-- <button class="btn btn-primary col-sm-3" type="button" (click)="unregister()">Login</button> -->
                <button class="col-sm-3" mat-raised-button color="primary" (click)="loginbtn()">Login</button>
                <!-- <button class="col-sm-3 leftmargin" mat-raised-button color="primary" (click)="reset()">Reset</button> -->
                <!-- <button class="btn btn-primary col-sm-3" type="button" >Login</button> -->
                <!-- <button class="btn btn-primary col-sm-3 leftmargin" type="button">Reset</button> -->
              </div>


            </form>
          </div>
          <div class="card-footer px-lg-5 py-lg-4">
            <!-- <div class="text-sm text-muted">Don't have an account? <a (click)="user_register()">Register</a>.</div> -->
            <div class="text-sm text-muted"> <a (click)="forgot_Password()">Forgot your password?</a>.</div>
          </div>
        </div>
        <!-- <div class="card-footer textalign py-lg-4">
        <div class="text-sm text-muted">Copyright 2023. All rights reserved.</div>
      </div> -->
      </div>
      <!-- forgotPassword -->
      <div class="d-none col-lg-8 px-lg-4" *ngIf="forgotPassword">
        <div class="card">
          <div class="card-header px-lg-5">
            <div class="card-heading text-primary">
              <h1>One-Qms</h1>
            </div>
          </div>
          <div class="card-body p-lg-5">
            <h3 class="mb-4">Forgot Password</h3>
            <form action="index.html">
              <div class="form-floating mb-3">
                <input class="form-control" id="organisationName" type="email" [(ngModel)]="userSettings.orgName"
                  placeholder="Organisation Name" [ngModelOptions]="{standalone: true}" required>
                <label for="organisationName">Organisation Name</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control" id="floatingInput" type="username" [(ngModel)]="userSettings.userName"
                  [ngModelOptions]="{standalone: true}" placeholder="Username" required>
                <label for="username">Username</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control" id="floatingInput" type="email" [(ngModel)]="userSettings.emailAddress"
                  placeholder="Email address" [ngModelOptions]="{standalone: true}" required>
                <label for="floatingInput">Email address</label>
              </div>
              <!-- <div class="form-check mb-3">
          <input class="form-check-input" type="checkbox" name="agree" id="agree">
          <label class="form-check-label" for="agree">I agree with the <a href="#">Terms & Conditions</a>.</label>
        </div> -->
              <div class="form-group textalign">
                <button class="col-sm-3" mat-raised-button color="primary"
                  (click)="send_forgot_Password()">Send</button>
                <!-- <button class="btn btn-primary" id="regidter" type="button" name="registerSubmit">Register</button> -->
              </div>
            </form>
          </div>
          <div class="card-footer px-lg-5 py-lg-4">
            <div class="text-sm text-muted">Already have an account? <a (click)="user_login()">Login</a>.</div>
          </div>
        </div>
      </div>









      <!-- register -->
      <div class="col-lg-8 px-lg-4" *ngIf="userregister">
        <div class="card">
          <div class="card-header px-lg-5">
            <div class="card-heading text-primary">Jassa Register</div>
          </div>
          <div class="card-body p-lg-5">
            <h3 class="mb-4">Get started with Chamkila</h3>
            <p class="text-muted text-sm mb-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              tempor incididunt ut labore.</p>
            <form action="index.html">
              <div class="form-floating mb-3">
                <input class="form-control" id="username" type="email" placeholder="name@example.com" required>
                <label for="username">Username</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control" id="floatingInput" type="email" placeholder="name@example.com" required>
                <label for="floatingInput">Email address</label>
              </div>
              <div class="form-floating mb-3">
                <input class="form-control" id="floatingPassword" type="password" placeholder="Password" required
                  noCopyPaste>
                <label for="floatingPassword">Password</label>
              </div>
              <div class="form-check mb-3">
                <input class="form-check-input" type="checkbox" name="agree" id="agree">
                <label class="form-check-label" for="agree">I agree with the <a href="#">Terms & Conditions</a>.</label>
              </div>
              <div class="form-group">
                <button class="btn btn-primary" id="regidter" type="button" name="registerSubmit">Register</button>
              </div>
            </form>
          </div>
          <div class="card-footer px-lg-5 py-lg-4">
            <div class="text-sm text-muted">Already have an account? <a (click)="user_login()">Login</a>.</div>
          </div>
        </div>
      </div>
      <div class="col-lg-8  text-primary rightSideDesign card">
        <!-- <label *ngIf="oneQmsOrgImagesDetails.logoImage ==null" class="loginName">One<span style="color: gold">QMS</span></label> -->
        <img *ngIf="oneQmsOrgImagesDetails.logoImage ==null" src="../../assets/img/oneqmslogo.png"
          style="height: 30px;width: 50%;">
        <div class="d-flex justify-content-end">
          <img *ngIf="oneQmsOrgImagesDetails.logoImage !=null" height="100" width="100"
            src="data:image/jpg;base64,{{oneQmsOrgImagesDetails.loginImage}}">


        </div>
        <!--     <h1 class="mb-4">One-QMS</h1>
        <p class="lead text-muted">Reduce Overall <b>Time</b> and <b>Cost</b> spent on <b>Clinical Trials</b> and <b>Redefining</b> your <b>End-to-End IT Ecosystem</b> with <b>Innovative Technologies</b>.</p> -->
        <div class="" *ngIf="userlogin">
          <div style="padding: 140px;padding-left: 25%;padding-right: 30%;">
            <h4 class="mb-4" style="color: #0F3659;">Hi, Welcome Back!</h4>
            <form id="loginForm" action="index.html" #form="ngForm">
              <div class="form-floating mb-3">
                <div><label>Username</label></div>
                <div class="d-flex align-items-center">
                  <input class="form-control " [type]="changetypeAddAndEdituSER ? 'password' : 'text'"
                    id="floatingInput" autocomplete="off" [(ngModel)]="userSettings.userName"
                    (focusout)="onFocusOutEvent($event)" [ngModelOptions]="{standalone: true}"
                    placeholder="Enter your username" required noCopyPaste>
                  <span class="eyeicon-container eye-color" (click)="showUserName()" *ngIf="showEyeIconForUserName">
                    <i
                      [class]="changetypeAddAndEdituSER ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
                  </span>

                </div>
              </div>
              <div class="form-floating mb-3">
                <div><label>Password</label></div>
                <div class="d-flex align-items-center">
                  <input class="form-control" name="floatingPassword1"
                    [type]="changetypeAddAndEditPassword ? 'password' : 'text'" id="floatingPassword1"
                    [(ngModel)]="userSettings.password" placeholder="Enter your password" required autocomplete="off"
                    onpaste="return false;" ondrop="return false;" noCopyPaste>
                  <span class="eyeicon-container eye-color" (click)="showPassword()">
                    <i
                      [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
                  </span>
                </div>
              </div>
              <div *ngIf="organisationName">
                <div class="form-floating mb-3">
                  <div><label>Organisation Name</label></div>
                  <div>
                    <input class="form-control" id="floatingInput" type="text" [(ngModel)]="userSettings.orgName"
                      placeholder="Organisation Name" [ngModelOptions]="{standalone: true}" required>
                  </div>
                </div>
              </div>
              <div class="form-check mb-3" style="text-align: end;">
                <label (click)="forgot_Password()">Forgot Password?</label>
              </div>
              <div class="textalign">
                <!-- <button class="btn btn-primary col-sm-3" type="button" (click)="unregister()">Login</button> -->
                <div class="d-flex gap-3">
                  <span class="button-continer" style="width: 100%;">
                    <button style="width: 100%;" class="addIconContiner text-white px-4 reload_text"
                      (click)="loginbtn()">
                      Login
                    </button>
                  </span>
                </div>
                <!-- <button class="col-sm-3" mat-raised-button color="primary" (click)="loginbtn()">Login</button> -->
                <!-- <button class="col-sm-3 leftmargin" mat-raised-button color="primary" (click)="reset()">Reset</button> -->
                <!-- <button class="btn btn-primary col-sm-3" type="button" >Login</button> -->
                <!-- <button class="btn btn-primary col-sm-3 leftmargin" type="button">Reset</button> -->
              </div>


            </form>
          </div>
        </div>
        <div class="" *ngIf="forgotPassword">
          <div style="padding: 120px;">
            <h4 class="mb-4" style="color: #0F3659;">Forgot Password</h4>
            <form action="index.html">
              <div class="form-floating mb-3">
                <div><label>Organisation Name</label></div>
                <div>
                  <input class="form-control" id="organisationName" type="text" [(ngModel)]="userSettings.orgName"
                    placeholder="Organisation Name" [ngModelOptions]="{standalone: true}" required>
                  <!-- <label for="organisationName">Organisation Name</label> -->
                </div>
              </div>
              <div class="form-floating mb-3">
                <div><label>Username</label></div>
                <div>
                  <input class="form-control" id="floatingInput" type="text" [(ngModel)]="userSettings.userName"
                    [ngModelOptions]="{standalone: true}" placeholder="Username" required>
                  <!-- <label for="username">Username</label> -->
                </div>
              </div>
              <div class="form-floating mb-3">
                <div><label>Email address</label></div>
                <div>
                  <input class="form-control" id="floatingInput" type="text" [(ngModel)]="userSettings.emailAddress"
                    placeholder="Email address" [ngModelOptions]="{standalone: true}" required>
                  <!-- <label for="floatingInput">Email address</label> -->
                </div>
              </div>
              <div class="form-check mb-3" style="text-align: end;">
                <div class="text-sm text-muted">Already have an account? <a (click)="user_login()">Login</a>.</div>
              </div>
              <div class="form-group textalign">
                <button class="col-sm-3" mat-raised-button color="primary"
                  (click)="send_forgot_Password()">Send</button>
                <!-- <button class="btn btn-primary" id="regidter" type="button" name="registerSubmit">Register</button> -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #confirmationPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmation()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Confirmation</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 10px 10px;">
    <div>
      <div class="row">
        <p>To enhance the performance and speed of the app, we recommend clearing the cache periodically. This will help
          free up storage space and allow the app to run more smoothly.</p>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="deleteButton" (click)="okConfirmation()">
        OK
      </button>
    </div>
  </div>
</ng-template>
